import React from 'react'

const RsProStatusPage = React.lazy(() => import('pages/RsProStatus/RsProStatusPage'));
const RsProStatusAddPage = React.lazy(() => import('pages/RsProStatus/RsProStatusAddPage'));

const RsProStatusRoutes = [
    {
        path: '/rs-pro-status',
        exact: true,
        name: 'Danh sách tình trạng máy',
        function: 'RS_PRO_STATUS_VIEW',
        component: RsProStatusPage,
    },
    {
        path: '/rs-pro-status/add',
        exact: true,
        name: 'Thêm mới tình trạng máy',
        function: 'RS_PRO_STATUS_ADD',
        component: RsProStatusAddPage,
    },
    {
        path: '/rs-pro-status/detail/:rs_pro_status_id',
        exact: true,
        name: 'Chi tiết tình trạng máy',
        function: 'RS_PRO_STATUS_VIEW',
        component: RsProStatusAddPage,
    },
    {
        path: '/rs-pro-status/edit/:rs_pro_status_id',
        exact: true,
        name: 'Chỉnh sửa tình trạng máy',
        function: 'RS_PRO_STATUS_EDIT',
        component: RsProStatusAddPage,
    },
]

export default RsProStatusRoutes
